import { WorkItemFind, WorkItemFindResult } from '../../notification/work-item-request';
import { RpcBaseData } from '../rpc-base';

/**
 * RPC work item find request name and version.
 */
export class RpcWorkItemFindKey {
    public static command = 'WorkItemFind';
    public static version = '0.1.0';
}

/**
 * Rpc Find work item result data.
 */
export interface RpcWorkItemFind extends WorkItemFind, RpcBaseData { }

/**
 * Rpc Find work item result.
 */
export interface RpcWorkItemFindResult extends WorkItemFindResult { }
